<template>
  <td>
    <button class=" btn btn-primary-outline k-grid-edit-command m-1" @click="editHandler">
    <h5><i class="far fa-edit" ></i></h5>
    </button>

    <button class=" btn btn-primary-outline k-grid-remove-command m-1" @click="removeHandler">
      <h5><i class="far fa-trash-alt "></i></h5>
    </button>
  </td>
</template>
<script>
export default {
  props: {
    field: String,
    dataItem: Object,
    format: String,
    className: String,
    columnIndex: Number,
    columnsCount: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    editor: String,
  },
  methods: {
    editHandler: function () {
      this.$emit("edit", this.dataItem);
    },
    removeHandler: function () {
      if (confirm("Confirm deleting: " + this.dataItem.claimType)) {
        this.$emit("remove", this.dataItem);
      }
    },
  },
};
</script>